import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Church } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { PageHeader } from "../components/app/PageHeader";

export default function GkkProfiles() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/gkk-profiles").then((r) => setD(r.data)); }, []);
  if (user.role === "gkk_president" && user.gkk_id) return <Navigate to={`/gkk-profiles/${user.gkk_id}`} replace />;
  if (!d) return null;
  const zones = d.gkks.reduce((a, g) => ({ ...a, [g.zone || "No zone"]: [...(a[g.zone || "No zone"] || []), g] }), {});
  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Pastoral development" title="GKK Community Profiles" testId="profiles-header">
        One page per GKK with aggregate findings, strengths and pastoral initiatives. Listed by zone and GKK ID — never ranked.
      </PageHeader>
      {Object.entries(zones).map(([zone, list]) => (
        <section key={zone} data-testid={`zone-${zone.replace(/\s/g, "-").toLowerCase()}`}>
          <h2 className="mb-3 font-serif-display text-2xl font-semibold text-amber-900">{zone}</h2>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((g) => (
              <Link key={g.gkk_id} to={`/gkk-profiles/${g.gkk_id}`} className="rounded-xl border border-amber-700/15 bg-white p-4 hover:border-amber-700/40 transition-colors" data-testid={`profile-card-${g.gkk_id}`}>
                <p className="flex items-center gap-2 text-[10px] uppercase tracking-widest font-semibold text-amber-800/80"><Church className="h-3 w-3" />{g.code || "—"}</p>
                <p className="mt-1 font-semibold text-stone-800">{g.patron || g.name}</p>
                <p className="text-xs text-stone-500">{g.local_area}</p>
                <p className="mt-2 text-xs text-stone-600">{g.households_latest} households surveyed ({d.period || "no period"}) · {g.plans_active} active plan(s)</p>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
